(function () {
  var shippingProtectionEnabled = window.theme.settings.shippingProtection.enabled;
  var shippingProtectionVariantId = window.theme.settings.shippingProtection.variantId;
  var handlingCartMerge = false; // Flag to prevent infinite loop
  var addingShippingProtection = false; // Flag to prevent multiple additions

  if (shippingProtectionEnabled) {
    var shippingProtectionCheckbox = document.getElementById('shipping-protection');

    // Function to check if Shipping Protection is already in the cart
    function isShippingProtectionInCart(cart) {

      let shippingProtectionFound = cart.items.some(item => item.id === parseInt(shippingProtectionVariantId));
      console.log('shippingProtectionFound= ' + shippingProtectionFound);
      return shippingProtectionFound;
    }

    function addShippingProtection() {

      if (addingShippingProtection) return; // Prevent concurrent additions
      addingShippingProtection = true;
      const shippingProtectionVariantId = parseInt(window.theme.settings.shippingProtection.variantId);

      console.log('Starting to add Shipping Protection.');
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Fetched cart:', cart);
          if (isShippingProtectionInCart(cart)) {
            console.log('Shipping Protection is already in the cart.');
            refreshCart();
            addingShippingProtection = false;
            return Promise.resolve();
          }

          console.log('Shipping Protection is not in the cart, adding it now.');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: shippingProtectionVariantId,
                quantity: 1
              }]
            })
          })
            .then(() => {
              console.log('Shipping Protection added, fetching cart again.');
              return fetch('/cart.js');
            })
            .then(response => response.json())
            .then(updatedCart => {
              console.log('Updated cart after adding:', updatedCart);
              addingShippingProtection = false;
              return Promise.resolve();
            });
        })
        .then(() => {
          console.log('Refreshing cart...');
          refreshCart();
        })
        .catch(error => {
          console.error('Error in adding Shipping Protection:', error);
          addingShippingProtection = false;
        });
    }

    // Function to remove Shipping Protection from the cart using native fetch API
    function removeShippingProtection() {
      var updates = {};
      updates[parseInt(shippingProtectionVariantId)] = 0;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          refreshCart();
        })
        .catch(function (error) {
          console.error('Error removing Shipping Protection:', error);
        });
    }

    // Function to handle Shipping Protection checkbox change event
    function handleShippingProtectionChange() {
      
      if (shippingProtectionCheckbox.checked) {
        addShippingProtection();
        saveChoiceToLocalStorage(true);
      } else {
        removeShippingProtection();
        saveChoiceToLocalStorage(false);
      }
    }

    // Function to initialize Shipping Protection functionality
    function initShippingProtection() {
      console.log('initShippingProtection called');
      const savedChoice = getSavedChoiceFromLocalStorage();
      //console.log('initShippingProtection: savedChoice=' + savedChoice);
      if (savedChoice !== null) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (savedChoice && cart.items.length > 0) {
              shippingProtectionCheckbox.checked = savedChoice;
              addShippingProtection();
            } else {
              shippingProtectionCheckbox.checked = false;
              removeShippingProtection();
            }
          })
          .catch(error => console.error('Error initializing Shipping Protection:', error));
      } else {
        fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var shippingProtectionDefault = window.theme.settings.shippingProtection.default;
            var isShippingProtectionAdded = isShippingProtectionInCart(cart);

            if (isShippingProtectionAdded) {
              shippingProtectionCheckbox.checked = true;
            } else if (shippingProtectionDefault && cart.items.length > 0) {
              shippingProtectionCheckbox.checked = true;
              addShippingProtection();
            } else {
              shippingProtectionCheckbox.checked = false;
            }            
          })
          .catch(function (error) {
            console.error('Error initializing Shipping Protection:', error);
          });
      }
      shippingProtectionCheckbox.addEventListener('change', handleShippingProtectionChange);
    }

    function saveChoiceToLocalStorage(choice) {
      const data = {
        choice: choice,
        timestamp: new Date().getTime()
      };
      localStorage.setItem('shippingProtectionChoice', JSON.stringify(data));

      //console.log('localStorage.setItem: ', data);
    }

    // Get the user's choice from local storage
    function getSavedChoiceFromLocalStorage() {
      const data = localStorage.getItem('shippingProtectionChoice');
      if (data) {
        const parsedData = JSON.parse(data);
        const now = new Date().getTime();
        const twelveHours = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
        if (now - parsedData.timestamp < twelveHours) {
          //console.log('GETTING SAVED CHOICE: ' + parsedData.choice);
          return parsedData.choice;
        }
        localStorage.removeItem('shippingProtectionChoice'); // Remove expired data
      }
      return null;
    }

    function refreshCart() {
      console.log('Cart refreshed.');
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    }

    // Function to handle Shipping Protection based on cart contents and user preference
    function handleShippingProtectionBasedOnCart() {
      if (handlingCartMerge) return; // Prevent infinite loop
      handlingCartMerge = true;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const savedChoice = getSavedChoiceFromLocalStorage();
          const shippingProtectionDefault = window.theme.settings.shippingProtection.default;
          const shippingProtectionInCart = isShippingProtectionInCart(cart);

          if (savedChoice) {
            if ((cart.items.length > 1 &&  !shippingProtectionInCart) || (cart.items.length === 1 && !shippingProtectionInCart)) {
              //console.log('handleShippingProtectionBasedOnCart: ADDING shipping protection due to saved choice');
              shippingProtectionCheckbox.checked = true;
              addShippingProtection();
            } else if (cart.items.length === 1 && shippingProtectionInCart) {
              //console.log('handleShippingProtectionBasedOnCart: REMOVING shipping protection because it is the only item');
              shippingProtectionCheckbox.checked = false;
              removeShippingProtection();
              resetCartCount();
            }
          } else if (savedChoice === null && shippingProtectionDefault && !shippingProtectionInCart) {
            if (cart.items.length > 1 || (cart.items.length === 1 && !shippingProtectionInCart)) {
              //console.log('handleShippingProtectionBasedOnCart: ADDING shipping protection due to default setting');
              shippingProtectionCheckbox.checked = true;
              addShippingProtection();
            } else if (cart.items.length === 1 && shippingProtectionInCart) {
              //console.log('handleShippingProtectionBasedOnCart: REMOVING shipping protection because it is the only item');
              shippingProtectionCheckbox.checked = false;
              removeShippingProtection();
              resetCartCount();
            }
          } else if (cart.items.length === 1 && shippingProtectionInCart) {
            //console.log('handleShippingProtectionBasedOnCart: REMOVING shipping protection because it is the only item');
            shippingProtectionCheckbox.checked = false;
            removeShippingProtection();
            resetCartCount();
          } else {
            //console.log('handleShippingProtectionBasedOnCart: No Action Required');
          }
        })
        .catch(error => console.error('Error handling Shipping Protection after cart merge:', error))
        .finally(() => {
          handlingCartMerge = false; // Reset the flag
        });
    }

    function resetCartCount() {
        // Find the element with the class 'cart-link__count'
        var cartCountElement = document.querySelector('.cart-link__count');
    
        // Check if the element exists
        if (cartCountElement) {
            // Update the text content of the element with the new count
            cartCountElement.textContent = '';
        }
    }
  

    // Event listener for cart merge event
    document.addEventListener('on:cart:after-merge', (event) => {   
      handleShippingProtectionBasedOnCart();
    });


    // Call initShippingProtection on page load
    document.addEventListener('DOMContentLoaded', initShippingProtection);
  }
})();
